import Vue from 'vue'
import Component from 'vue-class-component'
import {LogLevel} from '@/modules/app-router/model/ReleaseLog'

/**
 * Herramientas para los componente que muestran registros de eventos
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class LogMixin extends Vue {
    /**
     * Retorna un color representativo para el nivel de gravedad argumentado
     *
     * @param level
     */
    public levelColor (level: LogLevel) {
        switch (level) {
            case LogLevel.INFO:
            case LogLevel.DEBUG:
                return 'green'
            case LogLevel.NOTICE:
                return 'orange'
            case LogLevel.WARNING:
                return 'yellow'
            case LogLevel.ERROR:
            case LogLevel.ALERT:
            case LogLevel.CRITICAL:
            case LogLevel.EMERGENCY:
                return 'red'
        }
    }
}
